import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Reveal, SectionHead } from "@/components/Reveal";

const DOCS = [
  {
    id: "intake",
    tab: "Intake Form",
    testid: "preview-tab-intake",
    title: "CUSTOMER INTAKE & WORK AUTHORIZATION",
    lines: [
      ["Customer Name", "____________________________"],
      ["VIN", "____________________________"],
      ["Odometer", "____________  Fuel", "______"],
      ["Pre-existing damage", "☑ LF door scratch (photo #3)"],
      ["Diagnostic fee authorized", "$ 150.00"],
      ["Work cap authorized", "$ 850.00"],
    ],
    note: "“I acknowledge the pre-existing damage record above is accurate…”",
  },
  {
    id: "warranty",
    tab: "Warranty",
    testid: "preview-tab-warranty",
    title: "YOUR REPAIR WARRANTY — ONE PAGE",
    lines: [
      ["Parts", "12 months / 12,000 miles on parts we supply"],
      ["Our labor", "90 days on the specific repair performed"],
      ["Not covered", "Customer-supplied parts, abuse, wear items"],
      ["Claims", "Call us FIRST — before any other shop touches it"],
    ],
    note: "Sets expectations at pickup. Kills disputes at month three.",
  },
  {
    id: "terms",
    tab: "Repair Order T&C",
    testid: "preview-tab-terms",
    title: "REPAIR ORDER TERMS & CONDITIONS",
    lines: [
      ["§5 Storage", "$35/day after 48h completion notice"],
      ["§6 Mechanic's Lien", "Possession retained until paid in full"],
      ["§7 Warranty", "Written terms govern; all else disclaimed"],
      ["§8 Liability", "Capped at amount paid for the repair"],
    ],
    note: "The clauses that decide who pays when a job goes sideways.",
  },
  {
    id: "late-fee",
    tab: "Collections",
    testid: "preview-tab-late-fee",
    title: "LATE-PAYMENT ESCALATION — DAY 30",
    lines: [
      ["Re", "Final demand — Invoice #1042, Balance $1,240"],
      ["Deadline", "Payment in full within 10 days"],
      ["Remedies", "Mechanic's lien, collections, small claims"],
      ["Avoid", "Pay now: [Square link] or call the shop"],
    ],
    note: "Word-for-word scripts from friendly SMS to certified demand letter.",
  },
];

export default function Preview() {
  return (
    <section id="preview" className="relative py-24 lg:py-32 bg-panel/40">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Inside the Toolkit // Real Wording"
          title="Open the drawer before you buy"
          sub="Excerpts from the actual documents — no watered-down samples."
          align="center"
        />
        <Reveal delay={0.15}>
          <Tabs defaultValue="intake" className="mt-12">
            <TabsList className="w-full grid grid-cols-2 sm:grid-cols-4 bg-raised border border-slate-400/10 h-auto">
              {DOCS.map((d) => (
                <TabsTrigger
                  key={d.id}
                  value={d.id}
                  data-testid={d.testid}
                  className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.14em] py-3 data-[state=active]:bg-blaze data-[state=active]:text-white"
                >
                  {d.tab}
                </TabsTrigger>
              ))}
            </TabsList>
            {DOCS.map((d) => (
              <TabsContent key={d.id} value={d.id} className="mt-6">
                <div className="relative mx-auto max-w-2xl bg-[#F4F1EA] text-slate-800 p-8 sm:p-10 shadow-2xl rotate-[-0.6deg]">
                  <div className="absolute top-0 inset-x-0 h-2 bg-blaze" />
                  <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">The Mechanic's Tool Kit</p>
                  <h4 className="mt-2 font-display text-lg sm:text-xl font-extrabold uppercase tracking-tight text-slate-900">
                    {d.title}
                  </h4>
                  <div className="mt-5 space-y-3 border-t-2 border-slate-900/80 pt-5">
                    {d.lines.map((row, i) => (
                      <div key={i} className="flex justify-between gap-4 text-xs sm:text-sm">
                        <span className="font-semibold text-slate-700">{row[0]}</span>
                        <span className="font-mono text-slate-600 text-right">{row.slice(1).join("  ")}</span>
                      </div>
                    ))}
                  </div>
                  <p className="mt-6 text-xs italic text-slate-500 border-l-2 border-blaze pl-3">{d.note}</p>
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </Reveal>
      </div>
    </section>
  );
}
